/*
Handles "I want to change my PIN" as well as "I forgot my PIN"

nav prop reset brings this. reason may be set...

Forgot: 1. Start show loading. Get partial number on didMount. (GET /token/otp -> set state.partialNum)
        2. Ask for rest of number - (PUT /token/otp -> this will say sent or not -> state.readyForForm. And state.verifId)
		3. Ask for confirmation code & new PIN (POST /token/otp : code, id, newPIN)
		4. Go to normal PIN form

Change: 1. reason='change' -> Show old, new PIN, confirm. props.pin may be set to current pin!
		2. current_pin, new_pin -> put /token
		3. Logged in already so just go back!

Signup:	1. reason='temp' -> show Temp Pin, New, Confirm. Possibly props.pin might be set which would be temppin (still)
		2. not logged in, so go back to reset false, but perhaps pre-fill the PIN
		1A reason='nopin' -> show

Perhaps add react-native-android-sms-listener one day
*/

import React from 'react';
import NewPinForm from '../../forms/newPinForm';
import { Spinner, Text, Input, Button, View, Item, Label, Toast, H3 } from 'native-base';
import Alert from '../../components/alert';
import CalCalDataApi from '../../api/CalCalDataApi';

class ChangePin extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			partNo: '',
			readyForForm: false,
			verifyId: null,
			isError: false,
			error: null
		};
	}

	componentWillMount() {
		if (this.props.reason == 'forgot') {
			this.getPartialNum();
		} else {
			//change or forgot
			this.setState({ readyForForm: true, loading: false }); //skip to form
		}
	}

	componentWillReceiveProps(props) {
		if (props.reason == 'forgot' && this.props.reason != 'forgot') this.getPartialNum();
	}

	getPartialNum() {
		CalCalDataApi.dataLoadWithHeads(
			'token/otp',
			'',
			res => {
				//console.log(res);
				if (res && res.success) {
					this.setState({ readyForForm: false, loading: false, partialNum: res.partial_number });
				} else if (res && res.error == 'unverified') {
					this.setState({ readyForForm: false, loading: false, partialNum: res.partial_number, error: res.error });
				} else {
					this.setState({ isError: true, error: res.message });
				}
			},
			{ token: this.props.accessToken },
			true
		);
	}
	/*
	async saveRecord() {
		//button does this

		this.setState({ loading: true });
		errors = await this.refs.form.submit();
		//etc - set states and return errors
		console.log('errors', errors);
		if (errors != false) this.setState({ loading: false });
	}*/

	handleSubmit(values) {
		//form submitted
		this.setState({ loading: true });
		if (values.current_pin) {
			//we are changing based on current pin (OR temppin)
			CalCalDataApi.dataPutWithHeads(
				'token',
				{ new_pin: values.new_pin, current_pin: values.current_pin },
				'',
				res => {
					//console.log(res);
					if (res && res.success) {
						Alert.alert('Success', 'PIN successfully reset');
						//this.props.reset();
						this.props.login(values.new_pin);
						//this.props.navigation.goBack();
					} else if (res.message) {
						this.setState({ loading: false });
						Toast.show({ text: res.message, position: 'center', type: 'warning' });
					} else {
						this.setState({ isError: true });
					}
				},
				{ token: this.props.accessToken },
				true
			);
		} else {
			//SMS code received
			CalCalDataApi.dataPostWithHeads(
				'token/otp',
				{ id: this.state.verifyId, new_pin: values.new_pin, code: values.code },
				'',
				res => {
					//console.log(res);
					if (res && res.success) {
						//this.setState({ loading: false, readyForForm: res.success, verifyId: res.id, partialNum: null });
						//this.setState({ loading: false });
						Alert.alert('Success', 'PIN successfully reset');
						//this.props.reset();
						this.props.login(values.new_pin);
					} else if (res.message) {
						this.setState({ loading: false });
						Toast.show({ text: res.message, position: 'center', type: 'warning' });
					} else {
						this.setState({ isError: true });
					}
				},
				{ token: this.props.accessToken },
				true
			);
		}
	}

	componentDidMount() {}

	checkPartNo() {
		//check the last 3 digits entered - get a verifyID
		this.setState({ loading: true });
		CalCalDataApi.dataPutWithHeads(
			'token/otp',
			{ number: this.state.partNo },
			'',
			res => {
				//console.log(res);
				if (res && res.success) {
					this.setState({ loading: false, readyForForm: true, verifyId: res.id, partialNum: null, error: null });
				} else if (res.message) {
					this.setState({ loading: false });
					Toast.show({ text: res.message, position: 'center', type: 'warning' });
				} else {
					this.setState({ isError: true });
				}
			},
			{ token: this.props.accessToken },
			true
		);
	}

	render() {
		const { isError, partialNum, loading, partNo, readyForForm, error } = this.state;
		//__DEV__ && console.log(this.state);
		if (isError)
			return (
				<View padder>
					<H3 style={{ paddingBottom: 20 }}>Error! {error}</H3>
					<Button onPress={() => this.props.reset()}>
						<Text>Go back</Text>
					</Button>
				</View>
			);
		if (loading) return <Spinner />;
		if (partialNum || !!error)
			return (
				<View padder>
					{error == 'unverified' ? (
						<Text>
							Not received an SMS with your temporary PIN yet?{partialNum && ` We sent a message to +${partialNum}.`}
							{`\n \n`}Enter your mobile number to send another text message:
						</Text>
					) : (
						<Text>Please confirm the last 3 digits of your phone number to receive a one-off code</Text>
					)}
					<Item fixedLabel>
						<Label style={{ flex: 2 }}>{error == 'unverified' ? 'Your phone number' : partialNum}</Label>
						<Input
							style={{ borderColor: '#CCC', borderWidth: 1 }}
							autoFocus
							keyboardType={'numeric'}
							maxLength={error == 'unverified' ? 14 : 3}
							onSubmitEditing={() => this.checkPartNo()}
							onChangeText={c => this.setState({ partNo: c })}
						/>
					</Item>
					<Button full onPress={() => this.checkPartNo()} disabled={partNo.length < 3} style={{ marginTop: 10 }}>
						<Text>OK</Text>
					</Button>
				</View>
			);
		//console.log(this.state);

		if (!!readyForForm) return <NewPinForm partNo={partNo} reason={this.props.reason} onSubmit={this.handleSubmit.bind(this)} ref="form" navigation={this.props.navigation} />;
	}
}

export default ChangePin;
